import { Typography } from '@mui/material'
import React from 'react'
import { commify } from 'ethers/lib/utils'
import { FlexCol } from '@/components/common/Columns'
import { SupportedTicker, TICKERS_MAP_BY_NAME } from '@/constants/token'
import { formatNumber } from '@/utils'
import { useTokenPrice } from '@/hooks/useTokenPrice'

const AssetCell = ({
  tokenName,
  chainId,
  amount,
  showPrice,
}: {
  tokenName: SupportedTicker
  chainId: number
  amount: string
  showPrice?: boolean
}) => {
  const isOnBtc = chainId === 0

  const { data: price } = useTokenPrice(tokenName)

  const decimal = isOnBtc ? 18 : TICKERS_MAP_BY_NAME[tokenName].erc20Tokens[chainId].decimal

  return (
    <FlexCol sx={{ rowGap: 8 }}>
      <Typography sx={{ fontSize: '16px', fontWeight: 700 }}>
        {formatNumber(amount, decimal)} {tokenName}
      </Typography>

      {showPrice && (
        <Typography sx={{ fontSize: '16px', fontWeight: 400, opacity: 0.6 }}>
          $
          {typeof decimal === 'number' && typeof price === 'number'
            ? commify(
                (
                  Number(
                    formatNumber(amount.toString(), decimal, {
                      shouldCommify: false,
                    }),
                  ) * price
                ).toFixed(2),
              )
            : '-'}
        </Typography>
      )}
    </FlexCol>
  )
}

export default AssetCell
